import Head from "next/head";
import Layout from "../components/Layout";
import Breadcrumb from "@/components/BreadCrumb";

export default function Privacy() {
  return (
    <Layout>
      <Head>
        <title>Disclaimer | AstroLearn</title>
        <meta
          name="description"
          content="Read AstroLearn's disclaimer to understand how we protect your data while offering secure access to our online astrology courses."
        />
      </Head>
      <section>
        <Breadcrumb classNames="absolute top-20 left-4 lg:left-20" />
        <div className="container prose my-10 max-md:mt-12">
          <h1>Disclaimer</h1>
          <p>
            The information and materials provided on the AstroLearn website are
            for educational and informational purposes only and are provided
            &quot;as is.&quot; AstroLearn makes no warranties, express or
            implied, regarding the accuracy, completeness, or suitability of the
            content for any particular purpose. We disclaim all liability for any
            loss or damage arising from the use or inability to use the materials
            on this site. Any reliance on such information is strictly at your own risk. By accessing this website, you agree to comply with all applicable laws and these terms of use.
            {/* ESH Value Technologies Private Limited (referred to as &quot;the */}
            {/* Company&quot; or &quot;AstroLearn&quot;) values the privacy of users
            who access the website{" "}
            <a href="https://www.astrolearn.co/">https://www.astrolearn.co/</a>{" "}
            or engage with the Company through the web. */}
          </p>

        </div>
      </section>
    </Layout>
  );
}
